<div class="scroll-container"
  [class.horizontal-container]="orientation === 'horizontal'"
  [class.vertical-container]="orientation === 'vertical'">

  @if (showButtons && canScroll && canGoPrevious) {
    <div class="btn prev"
      [class.vertical]="orientation==='vertical'"
      [class.horizontal]="orientation==='horizontal'"
      (click)="previous()">
      @if (orientation === 'horizontal') {
        <mat-icon class="icon">chevron_left</mat-icon>
      }@else if(orientation === 'vertical'){
        <mat-icon class="icon">keyboard_arrow_up</mat-icon>
      }
    </div>
  }

  <div #content class="content"
    [class.horizontal]="orientation === 'horizontal'"
    [class.vertical]="orientation === 'vertical'"
    (scroll)="onScroll()">
    <ng-content></ng-content>
  </div>

  @if (showButtons && canScroll && canGoNext) {
    <div class="btn next"
      [class.vertical]="orientation==='vertical'"
      [class.horizontal]="orientation==='horizontal'"
      (click)="next()">
      
      @if (orientation === 'horizontal') {
        <mat-icon class="icon">chevron_right</mat-icon>
      }@else if(orientation === 'vertical'){
        <mat-icon class="icon">keyboard_arrow_down</mat-icon>
      }
    </div>
  }
</div>